import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'plugins-spinner',
  imports: [],
  templateUrl: './spinner.component.html',
  styleUrl: './spinner.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[attr.role]': 'role',
    '[attr.aria-busy]': 'aria',
  },
})
export class SpinnerComponent {
  readonly role = 'alert';
  readonly aria = 'true';
}
